<template>
    <v-container fluid style="padding: 30px 40px">
        <v-layout>
            <v-flex>
                <div style="text-align: left">
                    <h3 class="med-text blue-text" style="font-size:19pt">Help - Verification</h3>
                </div>
                <div style="text-align: left; margin-top: 10px">
                    <div style="display: flex; align-items: flex-start">
                        <v-icon color="yellow darken-3">mdi-chevron-double-right</v-icon>
                        <div style="margin-left: 15px">MSBSD has issued digital <span style="color: #999999">XXXXX_</span>legitdoc.zip certificates to students.</div>
                    </div><br/>

                    <div style="display: flex; align-items: flex-start">
                        <v-icon color="yellow darken-3">mdi-chevron-double-right</v-icon>
                        <div style="margin-left: 15px">The legitdoc.zip file consists of 2 files:<br/>
                            <b>1.</b> Marksheet/certificate in PDF format.<br/>
                            <b>2.</b> Blockchain proof key file in PDF format.
                            <br/></div>
                    </div>
                    <br/>
                    <div style="display: flex; align-items: flex-start">
                        <v-icon color="yellow darken-3">mdi-chevron-double-right</v-icon>
                        <div style="margin-left: 15px"><b>To verify</b>, directly upload or drag-and-drop the legitdoc.zip file on the verification portal.</div>
                    </div>
                    <br/>
                    <div style="display: flex; align-items: flex-start">
                        <v-icon color="yellow darken-3">mdi-chevron-double-right</v-icon>
                        <div style="margin-left: 15px"><b>To view</b> the contents of the certificate, open the corresponding pdf file inside the legitdoc.zip file.</div>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "HowItWorks",
    }
</script>

<style scoped>

</style>
